<template>
    <article class="table-responsive">
        <table class="table table-borderless">

            <thead>
                <tr>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Unit</th>
                    <th>Data Type</th>
                    <th>Minimal</th>
                    <th>Maximal</th>
                    <th>Category</th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(item, key) in dataItems" :key="key">

                    <td> <input class="form-control border border-dark" placeholder="Name" type="text" v-model.lazy.trim="item.name" /> </td>

                    <td> <input class="form-control border border-dark" placeholder="Code" type="text" v-model.lazy.trim="item.code" /> </td>

                    <td> <textarea class="form-control border border-dark" placeholder="Description" v-model.lazy.trim="item.description"></textarea> </td>

                    <td> <input class="form-control border border-dark" placeholder="Unit" type="text" v-model.lazy.trim="item.unit" /> </td>

                    <td>
                        <select
                            class="form-control border border-dark"
                            v-model="item.type"
                            title="Measurement data type cannot be changed after creation"
                            :disabled="isTypeInputDisabled(item)" >

                            <option value="-">Select data type</option>
                            <option value="int">Integer (0, 1, 2, 3, ...)</option>
                            <option value="float">Real number (0.1, 0.341, 2.567, 301.5, ...)</option>
                            <option value="bool">True or false</option>
                            <option value="string">Text</option>
                            <option value="json">List of values (defined under administration)</option>
                            <option value="date">Date</option>

                        </select>
                    </td>

                    <td>
                        <input
                            type="number"
                            class="form-control border border-dark"
                            :class="{'disabled' : (item.type !== 'int' && item.type !== 'float')}"
                            v-model.lazy.number="item.min"
                            :step="(item.type === 'float') ? '0.00000001' : '1'"
                            :disabled="(item.type !== 'int' && item.type !== 'float')" />
                    </td>

                    <td>
                        <input
                            type="number"
                            class="form-control border border-dark"
                            :class="{'disabled' : (item.type === 'bool' || item.type === 'json' || item.type === 'date')}"
                            v-model.lazy.number="item.max"
                            :step="(item.type === 'float') ? '0.00000001' : '1'"
                            :disabled="(item.type === 'bool' || item.type === 'json' || item.type === 'date')" />
                    </td>

                    <td>
                        <select class="form-control border border-dark" v-model="item.measurement_category_id">
                            <option value="null">Select category</option>
                            <option v-for="category in categories" :value="category.id" :key="category.id">
                                {{ category.name }}
                            </option>
                        </select>
                    </td>

                    <td>
                        <update-button :user-permissions="userPermissions" @click="update(item)">Save</update-button>
                        <delete-button :user-permissions="userPermissions" @click="onDelete(item)">Delete</delete-button>
                        <a
                            class="btn btn-sm btn-warning border border-dark"
                            :href=" host + '/data-collection/list/' + item.id + '/edit' "
                            v-if="(item.type === 'json' && item.id != null)" >
                            Edit list
                        </a>
                    </td>

                </tr>
            </tbody>

        </table>

        <add-button :user-permissions="userPermissions" @click="onAdd({})">New measurement</add-button>
        <status-feedback :successFeedback="successFeedback" :failFeedback="failFeedback" :errors="errors" ></status-feedback>

    </article>
</template>

<script>
import AjaxList from '../../mixins/AjaxListMixin';
import PermissionButtons from '../../mixins/PermissionButtonsMixin';
import Utils from '../../mixins/ObjectUtilsMixin';

export default {
    mixins : [AjaxList, PermissionButtons, Utils],

    props : {

        items : {
            type : Array,
            default : () => { return []; }
        },

        categories : {
            type : Array,
            default : () => { return []; },
        },

        dataSetId : {
            type : Number,
            required : true,
        }

    },

    data() {
        return {
            dataItems : this.items,
            url : `${APP_URL}/data-collection/data-set-type/${this.dataSetId}/measurement`,
            host : window.APP_URL
        };
    },

    methods: {

        update(item) {
            // let data = this.objectOnly(item, ['id', 'name', 'description', 'unit', 'type', 'measurement_category_id']);
            this.onUpdate(item);
        },

        isTypeInputDisabled(item) {
            return item && item.id;
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/data-set-type/DataSetTypeMeasurements.vue